import { SeverityEnum } from 'src/api/main/types.gen'

export const SEVERITY_COLORS: Record<SeverityEnum, string> = {
  [SeverityEnum.LOW]: 'var(--ant-color-success)',
  [SeverityEnum.MEDIUM]: 'var(--ant-color-warning)',
  [SeverityEnum.HIGH]: 'var(--ant-color-error)'
}

export const SEVERITY_TAG_COLOR: Record<SeverityEnum, string> = {
  [SeverityEnum.LOW]: 'success',
  [SeverityEnum.MEDIUM]: 'warning',
  [SeverityEnum.HIGH]: 'error'
}
